import React, { FC } from 'react';
import classNames from 'classnames';
import { ReactComponent as Tick } from '@/assets/icons/tick.svg';
import styles from './Radio.module.scss';

export interface RadioProps {
  value: string;
  title: string;
  price: string;
  isActive?: boolean;
  isCustom?: boolean;
  onClick?: (value: string) => void;
}

const Radio: FC<RadioProps> = ({
  value, title, price, onClick, isActive,
}: RadioProps) => {
  const clickHandler = (): void => {
    if (!onClick) {
      return;
    }

    onClick(value);
  };

  return (
    <div
      className={classNames(styles.container, isActive && styles.container_active)}
      onClick={clickHandler}
    >
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{price}</div>

      <div className={styles.tickContainer}>
        <Tick className={styles.tick} />
      </div>
    </div>
  );
};

export default Radio;
